export const menu = [
    {
        title: "Аналитика",
        icon: 'heroicons:chart-bar',
        persist: true,
        items: [
            {
                title: "Аналитика",
                items: [
                    {
                        title: "Дашборды",
                        route: "/analytics/dashboard",
                    },
                    {
                        title: "Мониторинг рынка",
                        route: "/analytics/market_monitoring",
                    },
                    {
                        title: "Продажи",
                        route: "/analytics/sales",
                    },
                    {
                        title: "Отчеты",
                        route: "/analytics/reports",
                    },
                    {
                        title: "Отчет по охвату мониторинга ",
                        route: "/analytics/monitoring-coverage",
                    },
                ]
            }
        ]
    },
    {
        title: "Ценообразование",
        icon: 'heroicons:banknotes',
        persist: true,
        items: [
            {
                title: "Ценообразование",
                items: [
                    {
                        title: "Ручная переоценка",
                        route: "/pricing/manualrepricing",
                    },
                    {
                        title: "Корректировки",
                        route: "/pricing/corrections",
                    },
                    {
                        title: "Установленные цены",
                        route: "/pricing/prices",
                    },
                    {
                        title: "Цены в мониторинге",
                        route: "/pricing/monitoring",
                    },
                ]
            },
            {
                title: "Остатки товаров",
                items: [
                    {
                        title: "Склады",
                        route: "/pricing/stock",
                    },
                    {
                        title: "Остатки на складах",
                        route: "/pricing/balance",
                    },
                    {
                        title: "Поставщики",
                        route: "/pricing/supplier",
                    },
                    {
                        title: "Остатки поставщиков",
                        route: "/pricing/bbalance-supplier",
                    }
                ]
            },
            {
                title: "Параметры ценообразования",
                items: [
                    {
                        title: "Политики",
                        route: "/pricing/politics",
                    },
                    {
                        title: "Каталог товаров",
                        route: "/pricing/catalog",
                        breadCrumbs: true
                    },
                    {
                        title: "Регионы",
                        route: "/pricing/regions",
                    },
                    {
                        title: "Типы цен",
                        route: "/pricing/pricetypes",
                    },
                ]
            },
            {
                title: "Автораспределение товаров",
                items: [
                    {
                        title: "Нераспределённые",
                        route: "/pricing/unallocated-products",
                    },
                    {
                        title: "Отложенные",
                        route: "/pricing/postponed",
                    },
                    {
                        title: "Правила",
                        route: "/pricing/autoallocation",
                    }
                ]
            }
        ]
    },
    {
        title: "Настройки ценообразования",
        icon: 'heroicons:adjustments-horizontal',
        items: [
            {
                title: "Настройки ценообразования",
                items: [
                    {
                        title: "Типы групп товаров",
                        route: "/setting/grouptypes",
                    },
                    {
                        title: "Группы регионов",
                        route: "/setting/region-groups",
                    },
                    {
                        title: "Группы типов цен",
                        route: "/setting/pricetype-groups",
                    },
                    {
                        title: "Уровни остатков",
                        route: "/setting/stock-levels",
                    },
                    {
                        title: "Уровни цен",
                        route: "/setting/price-levels",
                    },
                    {
                        title: "Функции",
                        route: "/setting/functions",
                    },
                    {
                        title: "Статусы товаров",
                        route: "/setting/product-statuses",
                    },
                    {
                        title: "Параметры",
                        route: "/setting/parameters",
                    },
                    {
                        title: "Значения параметров",
                        route: "/setting/value-parameters",
                    },
                    {
                        title: "Таблицы",
                        route: "/setting/tables",
                    },
                    {
                        title: "Варианты расчета цен",
                        route: "/setting/repricing-options",
                    },
                    {
                        title: "Расписание",
                        route: "/setting/schedule",
                    },
                    {
                        title: "Статистика \"Бигам\"",
                        route: "/setting/price-event",
                    },
                ]
            }
        ]
    },
    {
        title: "Настройки мониторинга",
        icon: 'heroicons:tv',
        items: [
            {
                title: "Настройки мониторинга",
                items: [
                    {
                        title: "Провайдеры",
                        route: "/monitoring/providers",
                    },
                    {
                        title: "Конкуренты",
                        route: "/monitoring/concurrents",
                    },
                    {
                        title: "Регионы конкурентов",
                        route: "/monitoring/concurrent-regions",
                    },
                    {
                        title: "Типы цен конкурентов",
                        route: "/monitoring/concurrent-pricetypes",
                    },
                    {
                        title: "Статусы товаров конкурентов",
                        route: "/monitoring/concurrent-product-statuses",
                    },
                    {
                        title: "Сопоставление товаров",
                        route: "/monitoring/product-matching",
                    }
                ]
            }
        ]
    },
    // {
    //     title: "Программа лояльности(для удаления)",
    //     icon: 'heroicons:star-solid',
    //     persist: true,
    //     items: [
    //         {
    //             title: "Программа лояльности",
    //             items: [
    //                 {
    //                     title: "Клиенты",
    //                     route: "/loyalty/clients",
    //                 },
    //                 {
    //                     title: "Карты",
    //                     route: "/loyalty/cards",
    //                 },
    //                 {
    //                     title: "События",
    //                     route: "/loyalty/events",
    //                 },
    //                 {
    //                     title: "Правила",
    //                     route: "/loyalty/rules",
    //                 },
    //                 {
    //                     title: "Движение параметров",
    //                     route: "/loyalty/event-schedule",
    //                 }
    //             ]
    //         },
    //         {
    //             title: "Настройки программы лояльности",
    //             items: [
    //                 {
    //                     title: "Типы карт",
    //                     route: "/loyalty/card-types",
    //                 },
    //                 {
    //                     title: "Типы событий",
    //                     route: "/loyalty/event-types",
    //                 },
    //                 {
    //                     title: "Значения параметров",
    //                     route: "/loyalty/value-parameters",
    //                 },
    //                 {
    //                     title: "Параметры",
    //                     route: "/loyalty/parameters",
    //                 },
    //                 {
    //                     title: "Политики",
    //                     route: "/loyalty/politics",
    //                 }
    //             ]
    //         }
    //     ]
    // },
    // {
    //     title: "Товарный маркетинг(для удаления)",
    //     icon: 'mdi:bullhorn-outline',
    //     persist: true,
    //     items: [
    //         {
    //             title: "Товарный маркетинг",
    //             items: [
    //                 {
    //                     title: "Промокоды",
    //                     route: "/marketing/promo-code",
    //                 },
    //                 {
    //                     title: "Бейджи",
    //                     route: "/marketing/badge",
    //                 },
    //                 {
    //                     title: "Правила",
    //                     route: "/marketing/rules",
    //                 },
    //                 {
    //                     title: "Условия",
    //                     route: "/marketing/conditions",
    //                 },
    //                 {
    //                     title: "Политики",
    //                     route: "/marketing/politics",
    //                 },
    //                 {
    //                     title: "Значения параметров",
    //                     route: "/marketing/value-parameters",
    //                 },
    //                 {
    //                     title: "События",
    //                     route: "/marketing/event",
    //                 },
    //             ],
    //         },
    //         {
    //             title: "Настройки",
    //             items: [
    //                 {
    //                     title: "Каналы продаж",
    //                     route: "/marketing/sales-channel",
    //                 },
    //                 {
    //                     title: "Приоритеты правил",
    //                     route: "/marketing/rule-priority",
    //                 },
    //                 {
    //                     title: "Параметры",
    //                     route: "/marketing/parameters",
    //                 },
    //                 {
    //                     title: "Типы событий",
    //                     route: "/marketing/event-types",
    //                 },
    //             ]
    //         },
    //         {
    //             title: 'Коммерческие приоритеты',
    //             items: [
    //                 {
    //                     title: "Коммерческие параметры",
    //                     route: "/marketing/commercial-parameters",
    //                 },
    //                 {
    //                     title: "Приоритеты",
    //                     route: "/marketing/commercial-priorities",
    //                 },
    //                 {
    //                     title: "Установка приоритетов",
    //                     route: "/marketing/commercial-rules",
    //                 }
    //             ]
    //         }
    //     ]
    // },
    {
        title: "Маркетинг",
        icon: 'heroicons:shopping-bag-16-solid',
        persist: true,
        items: [
            {
                title: "Данные",
                items: [
                    {
                        title: "Клиенты",
                        route: "/marketing-new/clients",
                    },
                    {
                        title: "Карты лояльности",
                        route: "/marketing-new/cards",
                    },
                    {
                        title: "Промокоды",
                        route: "/marketing-new/promo-code",
                    },
                    {
                        title: "Бейджи",
                        route: "/marketing-new/badge",
                    },
                    {
                        title: "Каналы продаж",
                        route: "/marketing-new/sales-channel",
                    },
                    {
                        title: "Значения параметров",
                        route: "/marketing-new/value-parameters",
                    }
                ]
            },
            {
                title: "Управление",
                items: [
                    {
                        title: "События",
                        route: "/marketing-new/events",
                    },
                    {
                        title: "Триггеры",
                        route: "/marketing-new/trigger",
                    },
                    {
                        title: "Политики",
                        route: "/marketing-new/politics",
                    },
                    {
                        title: "Движение параметров",
                        route: "/marketing-new/params-history",
                    },
                ]
            },
            {
                title: "Настройки",
                items: [
                    {
                        title: "Типы карт",
                        route: "/marketing-new/card-types",
                    },
                    {
                        title: "Типы событий",
                        route: "/marketing-new/event-types",
                    },
                    {
                        title: "Параметры",
                        route: "/marketing-new/parameters",
                    },
                ]
            },
            {
                title: 'Коммерческие приоритеты',
                items: [
                    {
                        title: "Коммерческие параметры",
                        route: "/marketing-new/commercial-parameters",
                    },
                    {
                        title: "Приоритеты",
                        route: "/marketing-new/commercial-priorities",
                    },
                    {
                        title: "Установка приоритетов",
                        route: "/marketing-new/commercial-rules",
                    }
                ]
            }
        ]
    },
    {
        title: "Управление витриной",
        icon: "heroicons:table-cells-solid",
        persist: true,
        items: [
            {
                title: "Планограммы",
                items: [{
                    title: "Управление",
                    route: "/showcase/management",
                }, {
                    title: "Аналитика",
                    route: "/showcase/analytic",
                }, {
                    title: "Созвездие",
                    route: "/showcase/constellation",
                }]
            }, {
                title: "Настройки",
                items: [{
                    title: "Магазины",
                    route: "/showcase/shop",
                }, {
                    title: "Витрины",
                    route: "/showcase/showcase",
                }, {
                    title: "Типы модулей",
                    route: "/showcase/type-module",
                }, {
                    title: "Шаблоны",
                    route: "/showcase/template",
                }, {
                    title: "Модули",
                    route: "/showcase/module",
                }]
            }
        ]
    },
    {
        title: "Интеграции",
        icon: 'heroicons:puzzle-piece',
        items: [
            {
                title: "Интеграции",
                items: [
                    {
                        title: "Загрузка товаров",
                        route: "/integration/upload_products",
                    },
                    {
                        title: "Загрузка продаж",
                        route: "/integration/uploadsales",
                    },
                    {
                        title: "Мои типы цен",
                        route: "/integration/mycosttypes",
                    },
                    {
                        title: "Курс валют",
                        route: "/integration/rates",
                    },
                    {
                        title: "Ошибки интеграции",
                        route: "/integration/errors",
                    },
                    {
                        title: "Расписание для переоценки ",
                        route: "/integration/repricing-schedule",
                    }
                ]
            }
        ]
    },
    {
        title: "Сообщение и задачи",
        icon: "heroicons-outline:chat-bubble-bottom-center-text",
        persist: true,
        items: [
            {
                title: "Сообщения",
                items: [{
                    title: "Команда",
                    route: "/workspace/team",
                }]
            },
            {
                title: "Задачи",
                items: [{
                    title: "Мои задачи",
                    route: "/workspace/inbox",
                }, {
                    title: "Я поставил",
                    route: "/workspace/assigned",
                }, {
                    title: "Все задачи",
                    route: "/workspace/tasks",
                }]
            }
        ]
    },
    {
        title: "Документация",
        icon: 'heroicons:document-text',
        bottom: true,
        persist: true,
        items: [
            {
                title: "API",
                items: [
                    {
                        title: "Маркетинг",
                        route: "/docs/marketing-event",
                    },
                ]
            }
        ]
    },
    {
        title: "Тестирование",
        icon: 'heroicons:code-bracket-square',
        bottom: true,
        persist: true,
        items: [
            {
                title: "Тестирование",
                items: [
                    {
                        title: "Политики",
                        route: "/testing/politic-test",
                    },
                    {
                        title: "Уровни цен",
                        route: "/testing/price-level-test",
                    },
                    {
                        title: "Функции",
                        route: "/testing/function-test",
                    },
                    {
                        title: "Политики лояльности",
                        route: "/testing/loyalty-politic-test",
                    },
                    {
                        title: "Политики маркетинга",
                        route: "/testing/marketing-politic-test",
                    },
                ]
            },
            {
                title: "Funny",
                items: [
                    {
                        title: "Разное",
                        route: "/testing/some",
                    },
                    {
                        title: "Snake",
                        route: "/testing/snake",
                    },
                    {
                        title: "Tetris",
                        route: "/testing/tetris",
                    },
                    {
                        title: "Miner",
                        route: "/testing/miner",
                    },
                ],
            }
        ]
    },
    {
        title: "Профиль",
        icon: 'heroicons:user-circle',
        bottom: true,
        items: [
            {
                title: "Профиль",
                items: [
                    {
                        title: "Профиль",
                        route: "/profile/profile",
                    },
                ]
            }
        ]
    },
    {
        title: "Настройка системы",
        icon: 'heroicons:cog-6-tooth',
        bottom: true,
        items: [
            {
                title: "Настройка системы",
                items: [
                    {
                        title: "Управление доступом",
                        route: "/systemsetting/access",
                    },
                ]
            }
        ]
    },
];
